import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
import { LegacyBanner } from './LegacyBanner';
export const BannerContent = ({ banner, className }) => {
    var _a, _b;
    // support for old crop values
    const isLegacyFormat = (banner.cropX !== undefined && banner.cropX !== 0) ||
        (banner.cropY !== undefined && banner.cropY !== 0);
    if (isLegacyFormat) {
        return _jsx(LegacyBanner, { banner: banner, className: className }, void 0);
    }
    return (_jsx("img", { srcSet: banner.urls
            ? `${banner.urls.small} 500w, ${banner.urls.medium} 1000w, ${banner.urls.large} 2000w`
            : undefined, src: (_b = (_a = banner.urls) === null || _a === void 0 ? void 0 : _a.large) !== null && _b !== void 0 ? _b : banner.url, style: {
            background: banner.dominantColorHex,
        }, className: clsx('w-full object-cover', className), alt: "" }, void 0));
};
//# sourceMappingURL=BannerContent.js.map